"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var mapStateToProps = function (state) { return ({
    isSaving: state.order.wizard.isSaving,
    status: state.order.wizard.values.status
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    orderReady: function (props) {
        return function () {
            var type = props.type === 'SINGLE'
                ? { type: 'ORDER' }
                : { type: 'AUTOMATIC_ORDER', mode: 'ORDER' };
            dispatch(WizardActions.createNewOrderRequest(type, props.currentFolder.id));
        };
    }
}); };
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, mapDispatchToProps), recompose_1.pure);
var component = enhance(function (props) { return (React.createElement("div", { className: 'order-wizard-step5' },
    React.createElement(sok_ui_1.RequestSpinner, { isLoading: (props.isSaving === 'STANDBY' || props.isSaving === 'SAVING') &&
            props.status === 'INITIAL', success: props.isSaving.includes('SAVED') }),
    React.createElement("p", null,
        props.status === 'INITIAL' &&
            (props.isSaving === 'STANDBY' || props.isSaving === 'SAVING') &&
            (0, translation_1.getLocalization)('userfront/order/generating'),
        props.isSaving.includes('SAVED') &&
            (0, translation_1.getLocalization)('userfront/order/created'),
        (props.isSaving === 'FAILED' || props.status === 'ERROR') &&
            (0, translation_1.getLocalization)('userfront/order/failed')),
    props.isSaving === 'FAILED' && (React.createElement("p", { className: 'error-button', onClick: props.orderReady(props) }, (0, translation_1.getLocalization)('userfront/order/tryAgain'))),
    props.isSaving.includes('SAVED') && (React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/order/thanks'))))); });
exports.default = component;
